export default __webpack_public_path__ + "static/media/shot-2.3c4ebff5.png";